export const setProcessList = (state, payload) => {
	state.processList = payload;
}

export const setObjProcessEdit = (state, payload) => {
  state.objProcessEdit = payload;
}

export const setFormValid = (state, payload) => {
  state.formValid = payload;
}

export const fncSetCommercialKams = (state, payload) => {
  state.commercialKams = payload;
}

export const fncSetCommercialOriginators = (state, payload) => {
  state.commercialOriginators = payload;
}

export const fncSetGeneratedLink = (state, payload) => {
  state.generatedLink = payload;
}

export const fncSetErfNumbers = (state, payload) => {

  state.erfNumbers = payload; 
}